import React, { createContext, useState } from 'react';
import * as signalR from '@aspnet/signalr';
import { apiRoutes } from '../AppSettings';

export const SignalRContext = createContext();

const SignalRContextProvider = (props) => {

    var wsconn = new signalR.HubConnectionBuilder()
                    .withUrl(apiRoutes.hubUrl, signalR.HttpTransportType.WebSockets)
                    .configureLogging(signalR.LogLevel.None).build();
    
    const [signalRConnection, setSignalRConnection] = useState(wsconn);
    const [stream, setStream] = useState({});

    const getCallerStream = () => {
        return stream;
    }

    const setCallerStream =(stream) => {
        setStream(stream);
    }

    const initializeConnection = () => {
        if(wsconn.connectionState == 0)
        {
            wsconn.start().then(() => { 
                console.log("SignalR: Connected"); 
                console.log((new Date))
            }).catch(err => 
                console.log(err)
            );
        }
        setSignalRConnection(wsconn);
    }


    const startConnection =()=> {
        console.log("SignalR Context: initializeConnection")
        initializeConnection();
    }

    const join = (userName) => {
        console.log("Joined: " + userName);
        wsconn.invoke("Join", userName).catch((err) => {
            console.log(err);
            //viewModel.Loading(false);
        });
    }

    return (  
        <SignalRContext.Provider value={{signalRConnection, startConnection, join, getCallerStream, setCallerStream}}>
            {props.children}
        </SignalRContext.Provider>
    );
}


export default SignalRContextProvider;